import React, { Suspense, useEffect } from 'react';
import { Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CopyRight from 'component/CopyRight';
import RouteWithSubRoutes from 'component/RouteWithSubRoutes';
import routes from './routeConfig';
import cooperationSDK from '../lib/cooperationSdk';
import AsyncComponent from 'component/AsyncComponent';
import Loading from 'component/Loading';
import { RootState } from 'model';
import { initializePointHubAfterLogin } from 'lib/pointHub';

const PointHubInitializer: React.FC = () => {
  const userInfo = useSelector((state: RootState) => state.user.userInfo);

  useEffect(() => {
    if (userInfo) initializePointHubAfterLogin();
  }, [userInfo]);

  return null;
};

const App: React.FC = () => {
  return (
    <Suspense fallback={<Loading />}>
      <PointHubInitializer />
      <Switch>
        {routes.map((route) => {
          return <RouteWithSubRoutes exact key={route.path} {...route} />;
        })}
      </Switch>
      <CopyRight />
    </Suspense>
  );
};

const getTokenBefore = new Promise((resolve, reject) => {
  if (cooperationSDK.isCoEnv) {
    Promise.all([cooperationSDK.fetchUserToken(), cooperationSDK.fetchUserInfo()])
      .then(() => {
        resolve(null);
      })
      .catch((e) => {
        return reject(e);
      });
    return;
  }

  resolve(null);
});

const AuthApp = () => <AsyncComponent aysncFn={getTokenBefore} asyncComponent={<App />} />;

export default AuthApp;
